const initBadgeScrollVisibility = (gallery) => {
  const badge = gallery.querySelector('.product__badges--image-overlay');
  if (!badge) return;

  const slides = gallery.querySelector('[data-product-media-list]');
  if (!slides) return;

  const allSlides = () => slides.querySelectorAll('[data-media-id]');

  // Mobile slider: hide when scrolled past 30% of the first slide
  const updateFromScroll = () => {
    const first = allSlides()[0];
    if (!first) return;
    badge.classList.toggle('badge--hidden', slides.scrollLeft > first.offsetWidth * 0.3);
  };

  // Mobile thumbs / variant selection: hide when any non-first media becomes active
  const updateFromMediaSelect = (e) => {
    const items = allSlides();
    if (!items.length) return;
    const selectedId = String(e.detail && (e.detail.id || e.detail.mediaId) || '');
    if (!selectedId) return;
    const firstId = items[0].dataset.mediaId || '';
    // data-media-id is "{sectionId}-{mediaId}"; event detail.id may be just the numeric part
    const isFirst = firstId === selectedId || firstId.endsWith('-' + selectedId);
    badge.classList.toggle('badge--hidden', !isFirst);
  };

  slides.addEventListener('scroll', updateFromScroll, { passive: true });
  gallery.addEventListener('theme:media:select', updateFromMediaSelect);
};

document.querySelectorAll('product-images').forEach(initBadgeScrollVisibility);
